import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig.js'; // Make sure to create authConfig.js file with loginRequest
import './login.css';
import logo from './icons/logo.png';
import vThink from './icons/vThink.png';
import { jwtDecode } from 'jwt-decode';

const Login = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [msalLoginStatus, setMsalLoginStatus] = useState('');
  const navigate = useNavigate();
  const { instance } = useMsal();


  const carouselImages = [
    {
      img: "./Confirmed attendance-pana.png",
      name: "Attendance Report",
      description: "Streamline attendance tracking and ensure accurate maintenance of records and historical data."
    },
    {
      img: "./Upload-pana.png",
      name: "Upload",
      description: "Facial recognition, time management tool and Greythr are diverse applications spanning biometric identification, productivity optimization, and human resources management, respectively."
    },
    {
      img: "./Research paper-rafiki.png",
      name: "Research",
      description: "Efficiently manage and analyze employee data through table view interfaces, generating detailed reports for workforce management"
    }
  ]

  const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
  
      // Decode the JWT token
      let decoded = jwtDecode(loginResponse.idToken);
  
      // Extract user-related information from the decoded payload
      const email = decoded?.preferred_username; // Assuming 'preferred_username' contains the email
      const name = decoded?.name;
      // Check if the user information is available and if the email is allowed
      const allowedEmails = ['ramani@vthink.co.in','manikandan@vthink.co.in','ombala@vthink.co.in' ,'anand.robertson@vthink.co.in','dhineshkumar@vthink.co.in', 'logeswaran@vthink.co.in', 'vignesh.dl@vthink.co.in','rizwan@vthink.co.in', 'swetha@vthink.co.in','malathi@vthink.co.in'];
      if (email && allowedEmails.includes(email.toLowerCase())) {
        setMsalLoginStatus('Microsoft Login successful');
        navigate('/home', { state: { username: name } });
      } else {
        setMsalLoginStatus('Unauthorized access');
      }
    } catch (error) {
      console.error('Microsoft Login Failure:', error);
      setMsalLoginStatus('Microsoft Login failed');
    }
  };
  

    const handleNextImage = () => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    };

    useEffect(() => {
      const intervalId = setInterval(() => {
        handleNextImage();
      }, 2000);

      return () => clearInterval(intervalId);
    }, [currentImageIndex]);

    return (
      <div style={{ backgroundColor: '#e9f2f7' }}>
        <div className='login'>
          <div className='loginPage'>
            <div style={{ paddingBottom: '50px' }}>
              <img className='vThink' src={vThink} alt='vThink' />
            </div>

            <div className='nextbox'>
              <div className='loginlogo'>
                <img src={logo} alt='logo' />
              </div>

              <button onClick={handleLogin}>Login with Microsoft</button>

              <p className='loginStatus'>{msalLoginStatus}</p>
            </div>
          </div>
          <div className="carasol">
            <img className='carasol' src={carouselImages[currentImageIndex].img} alt="carousel" />
            <div className="carousel-description">
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default Login;



